import React, { useCallback, useEffect, useState } from 'react';
import { supabaseClient } from '../../../config/supabase';
import Button3D from '../../ui/Button3D';
import RequestedEventsQueue from './RequestedEventsQueue';
import StaffStartEvent from './StaffStartEvent';
import { loadQueue } from './foundationApi';
import { workbookInvitees } from './workbookInvitees';
import './eventsFoundation.css';

// On the Events board: the "Requested events" alert and queue, staff start-on-behalf, and the way to Programs.
// Quiet (renders only its buttons) until the Events Foundation database update is live.
export default function EventsFoundationBar({ client = supabaseClient, canEdit = false, onOpenPlan, onOpenPrograms }) {
    const [count, setCount] = useState(null);
    const [open, setOpen] = useState(false);
    const [starting, setStarting] = useState(false);
    const [notice, setNotice] = useState('');
    const refresh = useCallback(() => loadQueue(client).then((rows) => setCount(Array.isArray(rows) ? rows.length : 0)).catch(() => setCount(null)), [client]);
    useEffect(() => { refresh(); }, [refresh]);
    if (count === null) return null;
    return (
        <div className="ef-panel mb-4" data-testid="events-foundation-bar">
            <div className="ef-alertbar" role={count ? 'status' : undefined}>
                <strong>{count ? `${count} event request${count === 1 ? '' : 's'} waiting for review` : 'No event requests waiting'}</strong>
                <div className="ef-actions">
                    <Button3D variant={count ? 'go' : 'light'} onClick={() => setOpen((v) => !v)} aria-expanded={open} data-testid="toggle-requests">{open ? 'Hide requests' : 'Requested events'}</Button3D>
                    {onOpenPrograms && <Button3D variant="light" onClick={onOpenPrograms}>Programs</Button3D>}
                    {canEdit && <Button3D onClick={() => setStarting(true)} data-testid="start-for-client">Start for a client</Button3D>}
                </div>
            </div>
            {notice && <p role="status">{notice}</p>}
            {open && <RequestedEventsQueue client={client} onCount={setCount} onOpenPlan={onOpenPlan ? (row) => onOpenPlan(row.event_id) : undefined} />}
            {starting && <StaffStartEvent client={client} readWorkbook={workbookInvitees} onClose={() => setStarting(false)} onCreated={() => { setNotice('Request created. It is waiting in Requested events.'); refresh(); }} />}
        </div>
    );
}
